var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHtgs3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 70,
    viewBox: "0 0 72 70",
    width: 72,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2e6fb7",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m70.2422 41.7734c-.865 0-1.568.704-1.568 1.569v23.207h-65.537v-23.207c0-.865-.704-1.569-1.569-1.569s-1.568.704-1.568 1.569v24.776c0 .865.703 1.569 1.568 1.569h68.674c.865 0 1.568-.704 1.568-1.569v-24.776c0-.865-.703-1.569-1.568-1.569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.8174 23.793c-.796 0-1.443.647-1.443 1.443v23.809h-20.938v-23.809c0-.796-.647-1.443-1.444-1.443h-7.141l19.052-20.268.183.194 18.873 20.074zm-10.863-23.368c-.254-.27-.638-.425-1.051-.425-.414 0-.798.155-1.053.426l-22.388 23.821c-.397.421-.503 1.033-.274 1.561.228.53.748.872 1.324.872h9.036v23.808c0 .796.648 1.444 1.444 1.444h23.825c.797 0 1.444-.648 1.444-1.444v-23.808h9.035c.578 0 1.097-.342 1.326-.87.229-.529.122-1.142-.274-1.563z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.0332 45.3726h6.476c.466 0 .845-.378.845-.846v-6.476c0-.467-.379-.845-.845-.845h-.309c-.467 0-.846.378-.846.845v4.476c0 .468-.379.846-.845.846h-4.476c-.467 0-.846.378-.846.846v.308c0 .468.379.846.846.846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.4277 18.7666c.506.294 1.165.193 1.557-.271l4.291-5.082c.436-.517.371-1.292-.148-1.729-.512-.46-1.293-.373-1.731.146l-4.291 5.082c-.437.518-.37 1.292.147 1.73.055.048.114.088.175.124"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtgs3);
export default __webpack_public_path__ + "static/media/htgs_3.d6d7fc7c07dd0b2dee13a4f0c13ec09c.svg";
export { ForwardRef as ReactComponent };